/**
 * Property referral commission tiers — must match backend `compute_property_commission`.
 * "Earn Up To 1% Rewards" — actual rate depends on the slab.
 */
export const COMMISSION_TIERS = [
    { maxValue: 10_00_000, type: "fixed", amount: 5000, label: "Up to ₹10 L → ₹5,000 fixed" },
    { maxValue: 25_00_000, type: "percent", rate: 0.25, label: "₹10 L – ₹25 L → 0.25%" },
    { maxValue: 50_00_000, type: "percent", rate: 0.20, label: "₹25 L – ₹50 L → 0.20%" },
    { maxValue: Infinity, type: "percent_range", minRate: 0.10, maxRate: 0.15, defaultRate: 0.15, label: "Above ₹50 L → 0.10–0.15% (admin)" },
];

/**
 * Compute the estimated commission for a given property price.
 * Returns { amount, rate, type, label, isRange }.
 */
export function estimateCommission(price) {
    const p = Number(price) || 0;
    for (const tier of COMMISSION_TIERS) {
        if (p <= tier.maxValue) {
            if (tier.type === "fixed") return { amount: tier.amount, type: "fixed", label: tier.label, isRange: false };
            if (tier.type === "percent") return { amount: Math.round(p * tier.rate / 100), rate: tier.rate, type: "percent", label: tier.label, isRange: false };
            if (tier.type === "percent_range") {
                const lo = Math.round(p * tier.minRate / 100);
                const hi = Math.round(p * tier.maxRate / 100);
                return { amount: hi, minAmount: lo, maxAmount: hi, rate: tier.defaultRate, type: "percent_range", label: tier.label, isRange: true };
            }
        }
    }
    return { amount: 0, type: "none", label: "" };
}

/** Pretty INR formatter (₹1,23,456 style). */
export function fmtINR(n) {
    if (n == null) return "—";
    return `₹${Math.round(n).toLocaleString("en-IN")}`;
}
